export default "__VITE_ASSET__DBasHI97__"